import { render, staticRenderFns } from "./land.vue?vue&type=template&id=20701380&scoped=true"
import script from "./land.vue?vue&type=script&lang=js"
export * from "./land.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20701380",
  null
  
)

/* custom blocks */
import block0 from "./land.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports